module.exports = __webpack_public_path__ + "img/73_.df660d2f.png";